import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import 'bootstrap-icons/font/bootstrap-icons.css';
import React from 'react';
import Home from './pages/Home';
import AboutUs from "./pages/AboutUs";
import CommercialCleaningServices from "./pages/CommercialCleaningServices";
import CommercialCleaningServicesNoida from "./pages/CommercialCleaningServicesNoida";
import CommercialCleaningServicesDelhi from "./pages/CommercialCleaningServicesDelhi";
import CommercialCleaningServicesGurugram from "./pages/CommercialCleaningServicesGurugram";
import CommercialCleaningServicesGhaziabad from "./pages/CommercialCleaningServicesGhaziabad";
import DonateUs from "./pages/DonateUs";
import Whyus from "./pages/Whyus";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Blog1 from './blogs/Blog1';
import Blog2 from './blogs/Blog2';
import Blog3 from './blogs/Blog3';
import Blog4 from './blogs/Blog4';
import Blog5 from './blogs/Blog5';
import Blog6 from './blogs/Blog6';
import Blog7 from './blogs/Blog7';
import Layout from './components/Layout';
import LandingLayout from './components/LandingLayout';
import ContactUs from './pages/ContactUs';
import ThankYou from './pages/ThankYou';
import Blogs from './blogs/Blogs';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import { Helmet } from 'react-helmet';
import PrivateSecurityServices from './pages/PrivateSecurityServices';
import SecurityGuardServices from './pages/SecurityGuardServices';
import HousekeepingManpower from './pages/HousekeepingManpower';
import PantryBoyServices from './pages/PantryBoyServices';
import AssemblyLineManpower from './pages/AssemblyLineManpower';
import HousekeepingManpowerService from './pages/HousekeepingManpowerService';
import HousekeepingManpowerNoida from './pages/HousekeepingManpowerNoida';
import HousekeepingManpowerDelhi from './pages/HousekeepingManpowerDelhi';
import HousekeepingManpowerGurugram from './pages/HousekeepingManpowerGurugram';
import HousekeepingManpowerGhaziabad from './pages/HousekeepingManpowerGhaziabad';
import AOS from "aos";
import "aos/dist/aos.css";
import NotFound from './pages/NotFound';
import ScrollToTop from './components/ScrollToTop';

AOS.init({
  duration: 1000,
  once: true,
});


function App() {
  return (
    
      <div className="App">
        <Helmet>
      <title>Professional Deep Cleaning Services in Noida with Helperji</title>
    <meta name="description" content="We offer affordable deep cleaning services in Noida, covering bathroom cleaning, toilet cleaning, and washroom cleaning services. Get in touch 24/7 with +91-7800-7800-95." />
     <meta name="keywords" content="Cleaning Services, Best Cleaning Services in Noida, Book Home Cleaning services Online in Noida, Washroom Cleaning Services in Noida, Office Cleaning Services in Noida, Bathroom Cleaning Services in Noida, Cleaning and Sanitization Services in Noida" />
        </Helmet>
      <BrowserRouter>
      <ScrollToTop />
        <Routes>
          <Route path='/' element={<Layout />}>
          <Route index element={<Home />} />
          <Route path='about-us' element={<AboutUs />} />
          <Route path='commercial-cleaning-services' element={<CommercialCleaningServices />} />
          <Route path='commercial-cleaning-services-noida' element={<CommercialCleaningServicesNoida />} />
           <Route path='commercial-cleaning-services-delhi' element={<CommercialCleaningServicesDelhi />} />
           <Route path='commercial-cleaning-services-gurugram' element={<CommercialCleaningServicesGurugram />} />
           <Route path='commercial-cleaning-services-ghaziabad' element={<CommercialCleaningServicesGhaziabad />} />
          <Route path='housekeeping-manpower-services' element={<HousekeepingManpower />} />
          <Route path='housekeeping-manpower-services-noida' element={<HousekeepingManpowerNoida />} />
          <Route path='housekeeping-manpower-services-delhi' element={<HousekeepingManpowerDelhi />} />
          <Route path='housekeeping-manpower-services-gurugram' element={<HousekeepingManpowerGurugram />} />
          <Route path='housekeeping-manpower-services-ghaziabad' element={<HousekeepingManpowerGhaziabad />} />
          <Route path='security-guard-services' element={<SecurityGuardServices />} />
          <Route path='private-security-services' element={<PrivateSecurityServices />} />
          <Route path='pantry-boy-services' element={<PantryBoyServices />} />
          <Route path='assembly-line-manpower' element={<AssemblyLineManpower />} />
          <Route path='donate-us' element={<DonateUs />} />
          <Route path='why-us' element={<Whyus />} />
          <Route path='privacy-policy' element={<Privacy />} />
          <Route path='terms-and-conditions' element={<Terms />} />
          <Route path='contact-us' element={<ContactUs />} />
          <Route path='thank-you' element={<ThankYou />} />
          <Route path='blogs' element={<Blogs />} />
          <Route path='*' element={<NotFound />} />
          <Route path='blog/high-quality-cleaning-services-in-noida' element={<Blog1 />} />
          <Route path='blog/professional-cleaning-services-in-noida' element={<Blog2 />} />
          <Route path='blog/commercial-cleaning-services-in-noida' element={<Blog3 />} />
          <Route path='blog/what-does-commercial-cleaning-service-include' element={<Blog4 />} />
          <Route path='blog/what-is-pantry-boy-duties-responsibilities' element={<Blog5 />} />
          <Route path='blog/how-to-choose-the-best-commercial-cleaning-service-in-delhi-ncr' element={<Blog6 />} />
          <Route path='blog/reliable-security-guard-services-in-noida-for-businesses' element={<Blog7 />} />
          </Route>
          <Route path='/' element={<LandingLayout />}> 
           <Route path='housekeeping-manpower-service' element={<HousekeepingManpowerService />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App;